import {
  isValidPersonDimex,
  isValidPersonId,
} from 'src/functions/identificationMethods';
import {
  number,
  NumberSchema,
  object,
  ObjectSchema,
  string,
  StringSchema,
} from 'yup';

export const MAX_BENEFICIARIES = 5;

const nameErrorMessage = 'El nombre es requerido';
const lastNameErrorMessage = 'El apellido es requerido';
const idTypeErrorMessage = 'El tipo de identificación es requerido';
const relationshipErrorMessage = 'El parentesco requerido';
const participationErrorMessage = 'Porcentaje a aplicar requerido';
const participationMaxErrorMessage =
  'Porcentaje incorrecto, el máximo es 100%.';
const emptyIdNumberError = 'El número de identificación es requerido';
const dimexFormatErrorValidation =
  'Debe iniciar con 1 y contener 12 caracteres';

type BeneficiariesRules = { [x: string]: StringSchema | NumberSchema };
const createBeneficiariesValidations = (): BeneficiariesRules => {
  const helper = new Array(MAX_BENEFICIARIES).fill(0);
  const validation: BeneficiariesRules = {};
  helper.forEach((_, index) => {
    validation[`beneficiary${index}firstName`] = string().when(
      'totalBeneficiaries',
      {
        is: (value: number) => value > index,
        then: string().required(nameErrorMessage),
        otherwise: string(),
      },
    );
    validation[`beneficiary${index}lastName`] = string().when(
      'totalBeneficiaries',
      {
        is: (value: number) => value > index,
        then: string().required(lastNameErrorMessage),
        otherwise: string(),
      },
    );
    validation[`beneficiary${index}idType`] = string().when(
      'totalBeneficiaries',
      {
        is: (value: number) => value > index,
        then: string().required(idTypeErrorMessage),
        otherwise: string(),
      },
    );
    validation[`beneficiary${index}id`] = string().when('totalBeneficiaries', {
      is: (value: number) => value > index,
      then: string()
        .when(`beneficiary${index}idType`, {
          is: 'N',
          then: string()
            .test(
              'Check id number format',
              'Formato de cédula inválida',
              isValidPersonId,
            )
            .required(emptyIdNumberError),
        })
        .when(`beneficiary${index}idType`, {
          is: 'U',
          then: string()
            .test(
              'Check DIMEX number format',
              dimexFormatErrorValidation,
              isValidPersonDimex,
            )
            .required(emptyIdNumberError)
            .max(12, dimexFormatErrorValidation),
        })
        .when(`beneficiary${index}idType`, {
          is: 'P',
          then: string().required(emptyIdNumberError),
        }),
      otherwise: string(),
    });

    validation[`beneficiary${index}relationship`] = string().when(
      'totalBeneficiaries',
      {
        is: (value: number) => value > index,
        then: string().required(relationshipErrorMessage),
        otherwise: string(),
      },
    );

    validation[`beneficiary${index}participationRate`] = number().when(
      'totalBeneficiaries',
      {
        is: (value: number) => value > index,
        then: number()
          .typeError(participationErrorMessage)
          .max(100, participationMaxErrorMessage),
        otherwise: number()
          .transform((value: number) =>
            Number.isNaN(value) ? undefined : value,
          )
          .nullable(),
      },
    );
  });
  return validation;
};

export default function makeValidationSchema(): ObjectSchema {
  const beneficiaryValidations = createBeneficiariesValidations();
  const validations = {
    totalBeneficiaries: number(),
    ...beneficiaryValidations,
  };
  return object().shape(validations);
}
